import React from 'react';
import {  SelectField, SmallBodyText } from '../../../../../ui-toolkit';
import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';
import { optionsFromDisplay } from '../../../../../ui-toolkit/enums/optionsFromDisplay';
import { DisplayOccupancyType, eOccupancyType } from '../../../../../ui-toolkit/orders/interfaces/eOccupancyType';

export const OccupancyType: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();

  const onUpdateOrder = async (value: string | null) => {
    await onPatchOrderInformation({ occupancyType: value ? eOccupancyType[value] : null });
  };

  return (
    <SummaryItemWithEdit
      label={'Occupancy Type'}
      tab={`other`}
      field={`occupancy_type`}
      onUpdate={(_: any, value) => onUpdateOrder(value)}
      order={order}
      editControl={SelectField}
      editProps={{ options: optionsFromDisplay(DisplayOccupancyType), isClearable: true }}
    >
      {order.transaction.occupancy_type ? (
        DisplayOccupancyType[order.transaction.occupancy_type]
      ) : (
        <SmallBodyText intent={`faded`}>-</SmallBodyText>
      )}
    </SummaryItemWithEdit>
  );
};
